import { useMemo, useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { ColDef } from "@ag-grid-community/core";
import { useRunService } from "../../api/runService";
import { useShowService } from "../../api/showService";
import {
  RunExpenseDataRow,
  RunExpenseDataRowAdapter,
} from "./RunExpenseDataRow";

const RunExpenseAnalytics = () => {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const { runs } = useRunService();
  const { shows } = useShowService();
  const [rowData, setRowData] = useState<RunExpenseDataRow[]>();

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
      aggFunc: "count",
      minWidth: 200,
      suppressAutoSize: false,
      filter: true,
      resizable: true,
      enableRowGroup: true,
    };
  }, []);

  const [columnDefs, _] = useState<ColDef[]>([
    {
      field: "run.name",
      headerName: "Run",
      sort: "desc",
      minWidth: 150,
      rowGroup: true,
      hide: true,
    },
    {
      field: "tag",
      headerName: "Tag",
      minWidth: 125,
      valueFormatter: (p: any) => p.value,
      enableRowGroup: true,
      rowGroup: true,
    },
    {
      field: "cost",
      headerName: "Projected Cost",
      valueFormatter: (p: any) => "$" + Math.floor(p.value).toLocaleString(),
      minWidth: 150,
      filter: false,
      aggFunc: "sum",
    },
    {
      field: "actualCost",
      headerName: "Actual Cost",
      valueFormatter: (p: any) => "$" + Math.floor(p.value).toLocaleString(),
      minWidth: 150,
      filter: false,
      aggFunc: "sum",
    },
    {
      field: "runWalkout",
      headerName: "Run Walkout",
      valueFormatter: (p: any) =>
        p.node.group ? "" : "$" + Math.floor(p.value).toLocaleString(),
      minWidth: 150,
      filter: false,
    },
    {
      field: "name",
      headerName: "Name",
       valueFormatter: (p: any) =>
        p.node.group ? "" : p.value || "",
      minWidth: 125,
      enableRowGroup: true,
    },
    {
      field: "notes",
      headerName: "Notes",
      valueFormatter: (p: any) =>
        p.node.group ? "" : p.value || "",
      minWidth: 200,
    },
  ]);

  const getData = async () => {
    if (!runs || !shows) {
      return;
    }
    setRowData(new RunExpenseDataRowAdapter().toContracts(runs, shows));
  };
  const cellSelection = useMemo(() => {
    return true;
  }, []);

  useEffect(() => {
    getData();
  }, [runs, shows]);
  return (
    <div style={containerStyle}>
      <div style={gridStyle} className={"ag-theme-quartz"}>
        <AgGridReact<RunExpenseDataRow>
          rowData={rowData}
          masterDetail={true}
          columnDefs={columnDefs}
          sideBar={{ toolPanels: ["columns", "filters"] }}
          rowGroupPanelShow={"always"}
          enableCharts={true}
          cellSelection={cellSelection}
          suppressAggFuncInHeader={true}
          defaultColDef={defaultColDef}
          groupDisplayType="multipleColumns"
        />
      </div>
    </div>
  );
};

export default RunExpenseAnalytics;
